import UpdateAppNotification from './UpdateAppNotification'
export default UpdateAppNotification
